import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scoreButton", "scoreKeyField"]

  connect() {
    console.log("Score form controller connected")
  }

  selectScore(event) {
    event.preventDefault()

    // Remove selected state from all buttons
    this.scoreButtonTargets.forEach(button => {
      button.classList.remove("border-sapphire", "bg-sapphire/10", "ring-2", "ring-sapphire")
      button.classList.add("border-gray-300")
    })

    // Add selected state to clicked button
    const button = event.currentTarget
    button.classList.remove("border-gray-300")
    button.classList.add("border-sapphire", "bg-sapphire/10", "ring-2", "ring-sapphire")

    // Set the hidden field value
    const scoreValue = button.dataset.scoreValue
    this.scoreKeyFieldTarget.value = scoreValue
  }
}
